import { z } from 'zod';

export const SystemConfigValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.array(z.unknown()),
  z.record(z.unknown())
]);

export const SystemConfigSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  configKey: z.string().min(1).max(100),
  configValue: SystemConfigValueSchema,
  description: z.string().optional(),
  createdAt: z.date(),
  updatedAt: z.date()
});

export interface SystemConfig extends z.infer<typeof SystemConfigSchema> {}

export const SystemConfigCreateSchema = SystemConfigSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});

export type SystemConfigCreateInput = z.infer<typeof SystemConfigCreateSchema>;

export const SystemConfigUpdateSchema = SystemConfigCreateSchema.partial();
export type SystemConfigUpdateInput = z.infer<typeof SystemConfigUpdateSchema>;

export const DEFAULT_SYSTEM_CONFIGS: Record<string, SystemConfig['configValue']> = {
  'schedule.advance_generation_days': 365,
  'schedule.cron_enabled': true,
  'schedule.default_duration_minutes': 60,
  'schedule.max_recurring_instances': 100,
  'schedule.reminder_days_before': 7
};
